import diacritics from 'diacritics'

let base = location.pathname

if (base.substr(-1) === '/') {
	base = base.substr(0, -1)
}

const event = function(category, action, label) {

	_paq = window._paq || []
	_paq.push(["trackEvent", category, action, label])

	if ("ga" in window && "function" === typeof window.ga) {
		ga('send', 'event', category, action, label);
	}

	window.dataLayer = window.dataLayer || []
	window.dataLayer.push({
		event: category,
		eventAction: action,
		eventLabel: label
	})

}

const pageView = function(url) {
	url = url.toLowerCase()
	url = url.replace(/\s+/g, '-')
	url = diacritics.remove(url)

	let _paq = window._paq || [];
    _paq.push(["setCustomUrl", url]);
    _paq.push(["trackPageView"]);

    if ("ga" in window && "function" === typeof window.ga) {
        ga('send', 'pageview', url);
	}
}

export {
	event,
	pageView
}

